import Vue from './vue-config'

if (document.getElementById('search')) {
    new Vue({
        el: '#search',
        data: {
            query: '',
            results: [],
            searched: false,
            page: 0,
            perPage: 18,
        },
        methods: {
            keydown(e) {
                if (e.keyCode != 13) this.searched = false
            },
            doSearch() {
                var vm = this
                vm.searched = true
                vm.doPost('/umbraco/surface/search/search', { query: vm.query }, (data) => {
                    vm.results = data
                })
            },
            setPage(p) {
                this.page = p
                window.scrollTo({
                    top: this.scrollTop,
                    behavior: 'smooth'
                })
            },
            setFilter(f) {
                this.filter = f
            }
        },
        computed: {
            pages() {
                return Math.ceil(this.results.length / this.perPage)
            },
            displayPage() {
                return this.page + 1
            },
            curPage() {
                return this.results.slice(this.page * this.perPage, (this.page * this.perPage) + this.perPage)
            },
            noResults() {
                return this.searched && this.query.length >= 3
                    && this.results.length == 0
            },
        },
        updated() {
            window.lazyLoad.update()
        },
        mounted() {
            var vm = this
            vm.scrollTop = vm.$el.querySelector('.search-results').offsetTop - 30
            if (vm.querystringObject.query) vm.query = vm.querystringObject.query
            vm.doSearch()
        }
    })
}